export const SET_USERS = 'SET_USERS';
export const SET_INVITES = 'SET_INVITES';
export const SET_PUBLISHERS = 'SET_PUBLISHERS';
export const SET_BUYERS = 'SET_BUYERS';
export const SET_ERROR = 'SET_ERROR';
export const SET_USER_VISIBLE_COLUMNS = 'SET_USER_VISIBLE_COLUMNS';
export const ADD_NEW_INVITE = 'ADD_NEW_INVITE';